// TODO: replace string literals with variables - (phyoh)
import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  ZRM_POST_A_LISTING_PAGE_VIEW: '4688',
};

// https://dataportal.zillowgroup.net/event-registry/2851
const PostAListingCTA = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2851',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_nav_component',
      trigger_source_nm: 'post_a_listing',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2853
const ListYourProperty = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2853',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'hero_image',
      trigger_source_nm: 'list_your_property',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2854
const ViewYourProperty = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2854',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'hero_image',
      trigger_source_nm: 'view_your_properties',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2855
const GetStartedModuleOne = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2855',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'module_1',
      trigger_source_nm: 'get_started',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2856
const AcceptApplications = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2856',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'applications_module',
      trigger_source_nm: 'accept_applications',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2857
const CreateALease = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2857',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'lease_module',
      trigger_source_nm: 'create_a_lease',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2858
const GetPaid = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2858',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'payments_module',
      trigger_source_nm: 'get_paid',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2859
const UpgradeToPremium = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2859',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'premium_module',
      trigger_source_nm: 'upgrade_to_premium',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2860
const GetStartedModuleSix = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '2860',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'module_6',
      trigger_source_nm: 'get_started',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5996
const ZRMHomePageView = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '5996',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_homepage',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4688
const ZRMPostAListingPageView = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ZRM_POST_A_LISTING_PAGE_VIEW,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_post_a_listing_page',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_post_a_listing_page',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6115
const ZRMViewPaidServicesImpression = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '6115',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'top_hero',
      trigger_source_nm: 'view_paid_services',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6116
const ZRMViewPaidServicesHeroClick = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '6116',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_hero',
      trigger_source_nm: 'view_paid_services',
    },
    semantic: {
      semantic_event_nm: 'click_false_door_test',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6117
const ZRMViewPaidServicesPromoBlockClick = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '6117',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_homepage',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'middle_upsell',
      trigger_source_nm: 'view_paid_services',
    },
    semantic: {
      semantic_event_nm: 'click_false_door_test',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

const ZRMHomePageCSEvents = {
  PostAListingCTA,
  ListYourProperty,
  ViewYourProperty,
  GetStartedModuleOne,
  AcceptApplications,
  CreateALease,
  GetPaid,
  UpgradeToPremium,
  GetStartedModuleSix,
  ZRMHomePageView,
  ZRMPostAListingPageView,
  ZRMViewPaidServicesImpression,
  ZRMViewPaidServicesHeroClick,
  ZRMViewPaidServicesPromoBlockClick,
};

// Clickstream visualizer data-eventid attributes
ZRMPostAListingPageView.data_event_id = EVENT_IDS.ZRM_POST_A_LISTING_PAGE_VIEW;

export default ZRMHomePageCSEvents;
